module.exports = __webpack_public_path__ + "img/logo.3b6e69b5.png";